const REFRESH_URL = `${process.env.REACT_APP_API_URL}/api/v1/auth-service/token/refresh`;

let refreshPromise = null;
export const getRefreshPromise = () => refreshPromise;

export const clearSessionAndRedirect = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    window.location.href = "/";
};

// Singleton promise prevents concurrent 401s from firing multiple refresh requests.
// All callers that arrive while a refresh is in flight share the same promise.
export const attemptTokenRefresh = () => {
    if (!localStorage.getItem("refreshToken")) return Promise.resolve(false);

    if (refreshPromise) return refreshPromise;

    refreshPromise = (async () => {
        try {
            const response = await fetch(REFRESH_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ refreshToken: localStorage.getItem("refreshToken") }),
            });
            if (!response.ok) return false;

            const data = await response.json();
            localStorage.setItem("token", data.token);
            localStorage.setItem("refreshToken", data.refreshToken);
            return true;
        } catch {
            return false;
        } finally {
            refreshPromise = null;
        }
    })();

    return refreshPromise;
};